import DatePicker from "react-datepicker";
import { DateTimePickerConfig } from "shared/form/core/types";
import { ScrollableTimePicker } from "./components/timepicker";
import DatePickerHeader from "./components/header";
import useDatePickerService from "./service";
import Button from "shared/components/button";
import { useCopies } from "shared/hooks/useCopies";
import Variant from "shared/enums/Variant";
import classNames from "classnames";
import { getDateFieldIcon } from "./utils";

export default function DateTimePicker({ autoComplete = "off", ...props }: DateTimePickerConfig) {
  const copies = useCopies();
  const service = useDatePickerService({ autoComplete, ...props });

  return (
    <DatePicker
      ref={service.ref}
      strictParsing
      id={props.name}
      name={props.name}
      onBlur={props.onBlur}
      showIcon
      icon={getDateFieldIcon({
        clickHandler: service.openDatePickerHandler,
        showTimeInput: service.showTimeInput,
        showTimeSelectOnly: props.formattingOptions?.showOnlyTime
      })}
      showPopperArrow={false}
      dateFormat={service.dateTimeFormat}
      timeFormat={service.dateTimeFormat}
      minDate={props.minDate}
      maxDate={props.maxDate}
      showYearDropdown={true}
      showMonthDropdown={true}
      preventOpenOnFocus={true}
      shouldCloseOnSelect={!service.showTimeInput} //Disabling auto close on select because for date and time input user should be able to select both date and time in one go
      onChange={service.changeHandler}
      disabled={props.disabled}
      selected={props.selected}
      autoComplete={autoComplete}
      openToDate={props.openToDate}
      placeholderText={props.placeholder}
      popperPlacement={"bottom-start"}
      filterTime={props.filterTime}
      filterDate={props.filterDate}
      portalId="datePicker-portal"
      showTimeSelectOnly={props.formattingOptions?.showOnlyTime}
      showTimeInput={service.showTimeInput}
      timeInputLabel={""}
      closeOnScroll={service.closeOnScrollHandler}
      customTimeInput={
        <ScrollableTimePicker
          key={"timePicker" + service.timePickerRefreshKey}
          selectedDate={props.selected}
          changeDate={props.onChange}
        />
      }
      renderCustomHeader={headerProps => <DatePickerHeader {...headerProps} />}>
      <div
        className={classNames("datePicker_actions", {
          timeOnly: props.formattingOptions?.showOnlyTime
        })}>
        {props.timeZoneDisplayStr ? (
          <span
            className="datePicker_actions-timezone"
            dangerouslySetInnerHTML={{ __html: copies.get("timezone.display", { 0: props.timeZoneDisplayStr }) }}
          />
        ) : (
          <span></span>
        )}
        <Button
          label={copies.get("datepicker.close.button")}
          variant={Variant.LINK}
          onClick={service.closeDatePickerHandler}
        />
      </div>
    </DatePicker>
  );
}
